import TableBackground from '../../components/Background/TableBackground';
import Diary from './Diary';

import './intro-scene.css';

interface IntroSceneProps {
    continueCb: () => void;
}

function IntroScene(props: IntroSceneProps) {
    const { continueCb } = props;
    return (
        <TableBackground>
            <div className="intro-scene" onClick={continueCb}>
                <Diary isIntro />
                <div className="start-game">Click anywhere to start</div>
            </div>
        </TableBackground>
    );
}

export default IntroScene;
